import { combineReducers } from 'redux';
import { ACTIVITY_REDUCER } from './activity';
import { USER_REDUCER } from './user';

export const ACCOUNT_REDUCER = combineReducers({
  USER: USER_REDUCER,
  ACTIVITY: ACTIVITY_REDUCER,
});
